import { Button, message } from 'antd';
import { isEmpty } from 'lodash-es';
import React, { ReactNode, useState } from 'react';
import { EditType } from '@/presentation/components/tapd-info/edit-tapd-modal';
import { BatchCreateTapdModal } from '@/presentation/components/tapd/batch-create/batch-create-tapd-modal';
import { EditTapdModal } from '@/presentation/components/tapd/edit-tapd-modal';
import { useStores } from '@/presentation/store';
import { Zone } from '@/proto/field';
import { IssueType } from '@/proto/issue';

export type BatchCreateTapdProps<T> = {
  type: Zone
  rows: T[];
  onSubmit: () => void;
  getIssueUrl: (data: T) => string;
  pageId: string;
  trigger?: ReactNode;
  issueType?: IssueType;
};

export const BatchCreateTapd = <T extends Record<string, any>>(props: BatchCreateTapdProps<T>) => {
  const [batchModalVisible, setBatchModalVisible] = useState(false);
  const [editTapdVisible, setEditTapdVisible] = useState(false);
  const [workspaceId, setWorkspaceId] = useState('');
  const [editType, setEditType] = useState<EditType>('add');
  const [rows, setRows] =  useState(props.rows);
  const [mode, setMode] = useState('');

  const { getFieldOptions } = useStores().IssueStore;
  const appVersionOptions = getFieldOptions('version').filter(item => !!item.value);

  const onBatchCreate = () => {
    const rows = props.rows.filter(row => isEmpty(row.tapdUrl));
    if (rows.length === 0) {
      message.warning('选中的问题均已提单！');
      return;
    }
    setRows(rows);
    setBatchModalVisible(true);
  };

  return <>
    <div onClick={onBatchCreate}>
      {props.trigger || <Button
        disabled={props.rows?.length === 0}
        style={{ marginRight: '12px' }}
      >
        批量提单
      </Button>}
    </div>
    <BatchCreateTapdModal
      issueType={props.issueType}
      appVersionOptions={appVersionOptions}
      visible={batchModalVisible}
      onHide={() => setBatchModalVisible(false)}
      rowsData={rows}
      pageId={props.pageId}
      type={props.type}
      onSubmit={props.onSubmit}
      getIssueUrl={props.getIssueUrl}
      onClose={() => setBatchModalVisible(false)}
      openEidtModal={(editType, mode) => {
        setEditTapdVisible(true);
        setEditType(editType);
        setMode(mode);
      }}
      onChangeId={(workspaceId: string) => setWorkspaceId(workspaceId)}
    />
    <EditTapdModal
      appVersionOptions={appVersionOptions}
      visible={editTapdVisible}
      workspaceId={workspaceId}
      mode={mode}
      editType={editType}
      onHideEdit={() => setEditTapdVisible(false)}
      openCreate={() => setBatchModalVisible(true)}
    />
  </>;
};
